/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
/* eslint-disable valid-typeof */
import React, { Component } from 'react';
import { isClient } from 'frontend/helpers/ssr-helper';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Helmet from 'react-helmet';
import BreadCrumb from '../paquetes-lista/breadcrumb-lista';
import Tabs from '../tabs/index';
import OfertasClient from '../../api/ofertas';
import Buscador from '../buscadores/buscador-vertical/buscador';
import Filtros from '../containers/filtros-ofertas';
import Contenido from './contenido-oferta';
import { getNavigation } from '../../redux/actions/application-actions';
import { SetOfertaOriginal } from '../../redux/actions/ofertas-actions';
import '../paquetes-lista/paquetes-lista.css';
import Common from '../../commons/commons';

const getParams = () => {
  if (!global.expressLocation && typeof 'window' === undefined) {
    return {
      url: '',
      title: '',
    };
  }

  const { pathname, search, host } = Common.getLocationInformation();
  const parts = pathname.replace('/buscarxpaquetes/ofertas/', '').split('/');
  return {
    url: `https://${host}${pathname}${search}`,
    title: parts[1],
  };
};

class OfertaLista extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filtrados: [],
      Preloader: true,
    };
    this.getOfertas = this.getOfertas.bind(this);
    this.ArmarOfferInformation = this.ArmarOfferInformation.bind(this);
  }

  componentDidMount() {
    this.getOfertas();
    this.props.getNavigation();
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillUpdate(nextProps) {
    if (nextProps !== this.props) {
      const { filtrados } = nextProps.offers;
      if (filtrados !== undefined && filtrados !== this.state['filtrados']) {
        this.setState({ filtrados });
      }
    }
  }

  getOfertas() {
    const { token } = this.props;
    const idOferta = this.ArmarOfferInformation();
    OfertasClient.obtenerPaquetesOfertas(idOferta, token).then((res) => {
      if (res !== null) {
        this.props.SetOfertaOriginal(res.data.offerInformation);
      }
      this.setState({ Preloader: false });
    });
  }

  ArmarOfferInformation = () => {
    return isClient ? window.location.pathname : ''.split('/')[3];
  }

  createSeoElements() {
    const { nombre } = this.props.application;
    const params = getParams();
    let tituloOferta = Common.filterText(params.title);
    tituloOferta = tituloOferta.charAt(0).toUpperCase() + tituloOferta.slice(1);

    const title = `${tituloOferta} | viaja con ${nombre}`;
    const description = `${tituloOferta}, aprovecha las mejores opciones para tus vacaciones con ${nombre}`;
    const paragraphTitulo = `${tituloOferta}, aprovecha las mejores opciones para tus vacaciones con ${nombre}`;
    const paragraph = `${tituloOferta},  aprovecha nuestras ofertas y paquetes especiales, contactá a nuestros expertos y encontrá la mejor atención. Somos la mejor opción para tus vacaciones, en ${nombre} tenemos las mejores ofertas de viajes, paquetes, vuelos y hoteles para vos!`;

    return {
      helmet: (
        <Helmet>
          <title>{ title }</title>
          <meta name='description' content={description} />
          <meta property='og:title' content={title} />
          <meta property='og:description' content={description} />
          <meta property='og:url' content={params.url} />
        </Helmet>
      ),
      paragraph: (
        <div className='container'>
          <div className='paragraph-seo-container'>
            <h2 className='color-dinamico'>{ paragraphTitulo }</h2>
            <p>{ paragraph }</p>
          </div>
        </div>
      ),
    };
  }

  render() {
    const { helmet, paragraph } = this.createSeoElements();
    // if (typeof window === "undefined") return (
    //   <Fragment>
    //     { helmet }
    //     {/* { paragraph } */}
    //   </Fragment>
    // );

    const { Preloader } = this.state;
    const { offers } = this.props;
    const mobile = typeof window === 'undefined' ? false : (isClient ? window.innerWidth <= 768 : false);

    return (
      <>
        { helmet }
        <Tabs />
        <div className='listado-paquetes'>
          <div className='listado'>
            <BreadCrumb originO={null} destinationO={null} searchMonthO={null} />
          </div>
          <div className='container'>
            <div className='row'>
              <div className='col-md-3'>
                <div className='btn-collapse-container hidden-lg hidden-md'>
                  <a
                    style={{ padding: '6px 0' }}
                    className='text-center hidden-lg hidden-md'
                    role='button'
                    data-toggle='collapse'
                    data-parent='#accordion-filtro-busqueda'
                    href='#collapseBuscador'
                    aria-expanded='false'
                    aria-controls='collapseBuscador'
                    id='collapse-buscador'
                  >
                    <i className='fa fa fa-search' />
                    {' '}
                    Editar busqueda
                  </a>

                  <a
                    style={{ padding: '6px 0' }}
                    className='text-center hidden-lg hidden-md color-dinamico-fondo'
                    role='button'
                    data-toggle='collapse'
                    data-parent='#accordion-filtro-busqueda'
                    href='#collapseFiltros'
                    aria-expanded='false'
                    aria-controls='collapseFiltros'
                    id='collapse-filtros'
                  >
                    <i className='fa fa fa-sliders' />
                    {' '}
                    Filtros
                  </a>
                </div>
                <div className='panel panel-default'>
                  <div id='collapseBuscador' className='panel-collapse collapse buscador' role='tabpanel' aria-labelledby='headingThree'>
                    {mobile ? <Buscador idUnico='mobile-searcher' /> : ''}
                    <div className='panel-heading hidden-lg hidden-md' role='tab' id='headingThree'>
                      <h4 className='panel-title text-center close-collapse' role='button' data-toggle='collapse' data-parent='#accordion-filtro-busqueda' href='#collapseBuscador' aria-expanded='false' aria-controls='collapseBuscador'>
                        <a className='collapsed'>
                          <i className='pull-right fa fa-chevron-up' />
                        </a>
                      </h4>
                    </div>
                  </div>
                </div>
                <div className=''>
                  <div id='collapseFiltros' className={`panel-collapse collapse ${mobile ? null : 'in'}`} role='tabpanel' aria-labelledby='headingThree'>
                    <Filtros original={offers.original} />
                    <div className='panel-heading hidden-lg hidden-md' role='tab' id='headingThree'>
                      <h4 className='panel-title text-center close-collapse' role='button' data-toggle='collapse' data-parent='#accordion-filtro-busqueda' href='#collapseFiltros' aria-expanded='false' aria-controls='collapseFiltros'>
                        <a className='collapsed'>
                          <i className='pull-right fa fa-chevron-up' />
                        </a>
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-md-9'>
                {
                  offers.filtrados !== undefined && (
                    <Contenido
                      preloader={Preloader}
                      ofertas={offers.filtrados}
                    />
                  )
                }
              </div>
            </div>
          </div>
          <br />
          <br />
          { paragraph }
        </div>
        <hr style={{ borderColor: '#d2d2d2', margin: '25px 0 0 0' }} />
      </>
    );
  }
}
const mapStateToProps = function (store) {
  return {
    actualModule: store.applicationState.navigation.actualModule,
    token: store.applicationState.token,
    offers: store.offers,
    application: store.applicationState,

  };
};
const mapDispatchToProps = (dispatch) => bindActionCreators({ getNavigation, SetOfertaOriginal }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(OfertaLista);
